import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useMemo } from "react";
import { applyConsent, getDefaultDecision } from "../others";
import { prepareTcfString } from "../tcf";
/**
 * Create actions for a passed context. If you want to use the actions, do not use
 * this hook directly, instead pass the result of this hook to your context and use
 * it with `useBanner`.
 */

function useBannerActions(setContextValue, toggleOverlay) {
  return useMemo(function () {
    var toggleWithActiveAction = function toggleWithActiveAction(type) {
      return setContextValue(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeAction: type,
          individualPrivacyOpen: true,
          refreshSiteAfterSave: type === "change" ? 2000 : false
        }, toggleOverlay(state, true));
      });
    };

    var cancelEvent = function cancelEvent(e) {
      if (!e) {
        return;
      }

      e.preventDefault(); // Some themes (e.g. AKEA) do have listeners on each link separately and do a custom redirect

      e.stopPropagation();
    };

    var actions = {
      openHistory: function openHistory(e) {
        toggleWithActiveAction("history");
        cancelEvent(e);
      },
      openBanner: function openBanner(e) {
        toggleWithActiveAction("change");
        cancelEvent(e);
      },
      revokeConsent: function revokeConsent(successMessage, e) {
        setContextValue(function (state) {
          var tcf = state.tcf;

          _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var buttonClicked, tcfString;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    // Do not rely on current state of `groups` because it can be altered through history change
                    buttonClicked = "shortcode_revoke"; // TCF compatibility: revoke TCF string

                    if (process.env.IS_TCF === "1" && tcf !== null && tcf !== void 0 && tcf.model) {
                      tcfString = prepareTcfString(tcf.model, buttonClicked);
                    }

                    _context.next = 4;
                    return applyConsent({
                      consent: {
                        groups: getDefaultDecision(true)
                      },
                      buttonClicked: buttonClicked,
                      tcfString: tcfString
                    });

                  case 4:
                    successMessage && alert(successMessage); // Always reload (always wait 2s to ensure opt-out scripts are exeucted)
                    // Fix iOS / Safari bug when we want to reload the page after a POST request

                    setTimeout(function () {
                      return window.location.reload();
                    }, 2000);

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))(); // Do not change anything


          return state;
        });
        cancelEvent(e);
      }
    }; // Make the actions available in our context

    setContextValue(function (state) {
      return _objectSpread(_objectSpread({}, state), actions);
    });
  }, [setContextValue, toggleOverlay]);
}

export { useBannerActions };